import { type FC, useState } from 'react';

import { Button } from '@ipfabric/ui-components/Button/Button';
import { Card } from '@ipfabric/ui-components/Card/Card';
import { ExportSidePanel } from './ExportSidePanel';
import { ImportSidePanel } from './ImportSidePanel';

type SidePanel = 'export' | 'import' | null;

export const ImportExportConfiguration: FC = () => {
  const [sidePanelOpen, setSidePanelOpen] = useState<SidePanel>(null);

  const importClickHandler = () => {
    setSidePanelOpen('import');
  };

  const exportClickHandler = () => {
    setSidePanelOpen('export');
  };

  const closeModalHandler = () => {
    setSidePanelOpen(null);
  };

  return (
    <>
      <Card>
        <div className='p flex flex-col gap'>
          <div className='text-level-5 font-semibold'>
            Import / Export IPF configuration
          </div>
          <div>
            Export full configuration or import configuration file from another
            IPF instance.
          </div>
          <div className='flex gap-xs max-w-96'>
            <Button
              className='flex-grow'
              variant='outline'
              onClick={importClickHandler}
              icon='fa-file-import'
            >
              Import configuration
            </Button>
            <Button
              className='flex-grow'
              variant='outline'
              onClick={exportClickHandler}
              icon='fa-file-export'
            >
              Export configuration
            </Button>
          </div>
        </div>
      </Card>
      {sidePanelOpen === 'export' && (
        <ExportSidePanel onClose={closeModalHandler} />
      )}
      {sidePanelOpen === 'import' && (
        <ImportSidePanel onClose={closeModalHandler} />
      )}
    </>
  );
};
